import { useTranslations } from "next-intl";
import { useClosetItemInShortReview, useMoveToNextClosetItemReview } from "@hooks/use-review-short";
import { useSizeReferenceDisplay } from "@hooks/use-current-user";
import Image from "@components/core/Image";
import Button from "@components/core/Button";
import ProductImage from "@components/core/ProductImage";
import translateVariantSize from "@utils/translateVariantSize";
import sizeTypes from "@utils/constants/sizeTypes";

function FitSatisfactionStep({ onSelect, scrollToTop }) {
  const t = useTranslations("common");

  const closetItem = useClosetItemInShortReview();
  const moveToNextClosetItemReview = useMoveToNextClosetItemReview();
  const sizeReference = useSizeReferenceDisplay();

  function skipClosetItemShortReview() {
    moveToNextClosetItemReview();
    scrollToTop();
  }

  const displaySize =
    closetItem?.variant.size &&
    !["size_tu", "size_multiple"].includes(closetItem.variant.size.type);

  return (
    <>
      <div className="pb-5 text-center d-flex flex-column align-items-center">
        <h5 className="mb-2">{t("review_short.how_fit")}</h5>
        <p className="mb-0 text-gray">{t("review_short.help_others")}</p>
      </div>

      <div className="closet-item-in-review">
        <div className="image-container">
          <ProductImage
            src={closetItem.product.main_picture_url}
            alt={closetItem.product.name}
            className="w-100"
            sizes="128px"
          />

          {displaySize && (
            <div className="size-container">
              <p className="mb-0">
                {translateVariantSize(
                  closetItem.variant.size?.type,
                  closetItem.variant.size?.value,
                  t,
                  sizeReference,
                )}
                {closetItem.variant.size?.type === sizeTypes.size_fr && (
                  <span> {sizeReference}</span>
                )}
              </p>
            </div>
          )}
        </div>

        <div className="d-flex gap-3 w-100 pb-4 mb-2">
          <button
            type="button"
            className="btn-transparent flex-grow-1 bg-white d-flex justify-content-center align-items-center py-3 flex-column gap-2 rounded"
            onClick={() => onSelect(true)}
          >
            <Image
              src="thumbsUp"
              alt={t("review_short.yes")}
              width={50}
              height={50}
            />
            {t("review_short.yes")}
          </button>
          <button
            type="button"
            className="btn-transparent flex-grow-1 bg-white d-flex justify-content-center align-items-center py-3 flex-column gap-2 rounded"
            onClick={() => onSelect(false)}
          >
            <Image
              src="thumbsDown"
              alt={t("review_short.no")}
              width={50}
              height={50}
            />
            {t("review_short.no")}
          </button>
        </div>

        <Button
          variant="ghost-primary"
          onClick={skipClosetItemShortReview}
        >
          {t("review_short.not_tried_yet")}
        </Button>
      </div>
    </>
  );
}

export default FitSatisfactionStep;
